export default class RegionCard {
  constructor({
    '#type': type,
    id,
    data_type: dataType,
    algorithm,
    title,
    alias,
    content,
    source,
    image_url: imageUrl,
    temps_de_lecture: lectureTime,
    hashtags,
  }) {
    this.type = type;
    this.id = id;
    this.dataType = dataType;
    this.algorithm = algorithm;
    this.title = title;
    this.alias = alias;
    this.content = content;
    this.source = source;
    this.imageUrl = imageUrl;
    this.lectureTime = lectureTime;
    this.hashtags = hashtags;
  }

  getTitle() {
    return this.title;
  }

  getContent() {
    return this.content;
  }

  getImageUrl() {
    return this.imageUrl;
  }

  getLectureTime() {
    return this.lectureTime;
  }

  getHashTags() {
    return this.hashtags;
  }

  getAlias() {
    return this.alias;
  }

  getSource() {
    return this.source;
  }
}
